import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FilterContainer, FilterOptions, FilterOption, ResetLink } from './FilterItem.style'
import FilterArrow from '../Icons/FilterArrow'
import { FILTER_SHOW_ALL, RESET_FILTER_TEXT_ALT } from '../../../locales'

class FilterItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
  }

  showOptions = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  }

  render() {
    const { isOpen } = this.state
    const { title, items, addFilter, activeFilter, clearFilter, showAllOption } = this.props

    return (
      <FilterContainer onClick={this.showOptions} open={isOpen}>
        {title}
        <svg viewBox="0 0 22 10">
          <FilterArrow />
        </svg>
        <FilterOptions>
          <ul>
            { showAllOption && (
              <FilterOption
                value="*"
                active={activeFilter === undefined || activeFilter.length === 0}
                onClick={(e) => {
                  clearFilter(e)
                }}
              >
                {FILTER_SHOW_ALL}
              </FilterOption>
            )}
            { items.map((filterItem) => (
              <FilterOption
                value={filterItem.value}
                type={filterItem.type}
                active={activeFilter && activeFilter.value === filterItem.value}
                key={filterItem.value}
                onClick={(e) => {
                  addFilter(e, filterItem)
                }}
              >
                {filterItem.value}
              </FilterOption>
            ))
            }

            {clearFilter && (
              <ResetLink
                onClick={(e) => {
                  clearFilter(e)
                }}
              >
                {RESET_FILTER_TEXT_ALT}
              </ResetLink>
            )}
          </ul>
        </FilterOptions>
      </FilterContainer>
    )
  }
}

FilterItem.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
    addFilter: PropTypes.func,
    clearFilter: PropTypes.func,
  })).isRequired,
  activeFilter: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  })),
  addFilter: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  showAllOption: PropTypes.bool,
}

FilterItem.defaultProps = {
  showAllOption: false,
  activeFilter: [],
}

export default FilterItem
